import { CAMPAIGN_TYPE } from "../constants";
const _ = require('lodash');

const campaignReducer = (state = {
  posts: [],
  products: []
}, action) => {
  switch (action.type) {
    case CAMPAIGN_TYPE.FETCH:
      return {
        ...state,
        ...action.payload
      };
    case CAMPAIGN_TYPE.POSTS:
      return {
        ...state,
        posts: action.payload
      }
    case CAMPAIGN_TYPE.DELETE_POSTS:
      return {
        ...state,
        posts: state.posts.filter((f) => f.post_id != action.payload)
      }
    case CAMPAIGN_TYPE.ADD_POSTS:
      return {
        ...state,
        posts: action.payload
      }
    case CAMPAIGN_TYPE.UPDATE:
      return {
        ...state,
        ...action.payload
      }
    case CAMPAIGN_TYPE.ADD_PRODUCTS:
      return {
        ...state,
        products: action.payload
      }
    case CAMPAIGN_TYPE.DELETE_PRODUCTS:
      return {
        ...state,
        products: state.products.filter((f) => !_.includes(action.payload, f.id))
      }
    case CAMPAIGN_TYPE.UPDATE_PRODUCT:
      return {
        ...state,
        products: state.products.map((m) => {
          if (m.id == action.payload.id) {
            return {
              ...m,
              ...action.payload
            }
          }
          return m
        })
      }
    default:
      return state;
  }
};

export default campaignReducer;